type Section = {
  id: string
  theme: 'yellow' | 'black'
  type: string
  element: HTMLElement | null
  chapterIndex: number
  chapterTitle: string | undefined
}

// Used to determine if Nitex logo should be yellow
const yellowThemedSections = [
  'BigHeadingWithMedia',
  'CenteredMedia',
  'DualMedia',
  'FullWidthMedia',
  'HeroFullMedia',
  'HeroDualMedia',
]

export default () => {
  const { $tweakpane } = useNuxtApp()

  const sections = useState<Section[]>('current-page-sections', () => [])

  const activeSection = useState<Section | undefined>('active-page-section', () => undefined)

  function activateChapterCloseToTop() {
    let isFound = false

    sections.value.forEach((section) => {
      if (isFound) return

      if (!section.element) {
        section.element = document.querySelector('#section-' + section.id) as HTMLElement
      }

      const { top } = section.element?.getBoundingClientRect() || { top: 100000 }

      // activate section (theme / chapter)
      if (top < 30) {
        activeSection.value = section
        isFound = true
      }
    })
  }

  watchEffect(() => {
    // just to trigger the watcher
    const _s = $tweakpane.PARAMS.scrollProgress

    activateChapterCloseToTop()
  })

  return {
    activeSection,
    refresh: activateChapterCloseToTop,
    setSectionsData(newSections: PageSection[]) {
      activeSection.value = undefined

      let chapterIndex = -1

      sections.value = newSections
        .map<Section>((section) => {
          const element = document.querySelector('#section-' + section.id) as HTMLElement

          const chapterTitle =
            'trumpet' in section.data && typeof section.data.trumpet === 'string'
              ? section.data.trumpet
              : undefined

          if (chapterTitle) {
            chapterIndex++
          }

          return {
            id: section.id,
            theme: yellowThemedSections.includes(section._type) ? 'yellow' : 'black',
            type: section._type,
            element,
            chapterIndex,
            chapterTitle,
          }
        })
        .reverse()
    },
  }
}
